import { Component } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";

@Component({
  selector: 'page-depths',
  templateUrl: 'depths.html'
})

export class DepthPage {
  
  public depths: any = [];
  public selected_depth: string = '';
  
  constructor(public navParams: NavParams, public viewCtrl: ViewController) {
    
    let tmp_depths = this.navParams.data.depths;
    //console.log('data: ', this.navParams.data);
    tmp_depths.forEach((depth: any) => {
       this.depths.push(depth);
    });
    this.selected_depth = this.navParams.data.selected
    //console.log('Depths: ', this.regions, this.selected_depth);
  }

  change_depth(item) {
    //console.log('Depth: ', item);
    this.selected_depth = item;
    this.close();
  }

  close() {
    //console.log('close: ', depth);
    this.viewCtrl.dismiss({
      depth: this.selected_depth
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/depths/depths.ts